// 數據回收模塊
export default {
    DataRecycling: {
        DataOverview: '數據概覽',
        UpdatedOn: '更新於',
        NewToday: '今日新增',
        TotalDataVolume: '總數據量',
        AverageAnswerTime: '平均答題時長',
        TopicStatistics: '題目統計',
        Export: '導出',
        Operate: '操作',
        Preview: '預覽',
        NumberOfRespondents: '回答人數',
        Download: '下載',
        LoadMore: '加載更多',
        ExportType: '導出類型',
        DataReport: '數據報表',
        ExportFormat: '導出格式',
        ExportCSV: '導出CSV',
        ExportToExcel: '導出Excel',
        ExportWord: '導出Word',
        Export: '導 出',
        ModifyQuestionnaireTip: '您確認修改此問卷嗎？該問卷所有數據收集將被停止，答卷鏈接暫時關閉！',
        ModificationPrompt: '修改提示',
        CustomTitle: '自定義標題',
        Pie: '餅圖',
        Histogram: '柱狀圖',
        BarChart: '條形圖',
        Ring: '圓環',
        StackedBarChart: '堆積柱狀圖',
        StackedBarChart: '堆積條形圖',
        RadarChart: '雷達圖',
        DataPreparationInProgress: '數據準備中，預計5分鐘後完成。前往',
        MyDownload: '我的下載',
        CanViewProgress: '可查看進度',
        Referrer: '訪問來源',
        ExportData: '導出數據',
        ExportChart: '導出圖表',
        PleaseSelect: '請選擇',
        StackedColumnChart: '堆疊柱狀圖',
        StackedBarChart: '堆疊條形圖',
        FoldLine: '折線',
        Filter: '篩選',
        FilterMeetsTheFollowingCriteria: '篩選符合以下',
        Data: '的數據',
        AnswerToTheQuestion: '題目答案',
        Delete: '刪除',
        ShowSatisfaction: '顯示滿足以下',
        AnswerSheet: '的答卷',
        AddFilterCriteria: '添加篩選條件',
        AnswerDate: '答題日期',
        To: '至',
        StartDate: '開始日期',
        EndDate: '結束日期',
        Clear: '清空',
        AllConditions: '全部條件',
        AnyCondition: '任意條件',
        All: '全部',
        Custom: '自定義',
        Selected: '選中',
        NotSelected: '未選中',
        IsEmpty: '為空',
        NotEmpty: '不為空',
        Contain: '包含',
        NotIncluded: '未包含',
        OnlySelect: '只選中',
        RestoreToDefault: '清空篩選條件後，篩選條件都將恢復為默認樣式',
        ConfirmEmptying: '確定清空',
        LoadError: '加載錯誤',
        QuestionBasedStatistics: '分題統計',
        CrossAnalysis: '交叉分析',
        SourceAnalysis: '來源分析',
        SubtitleStatisticsCopy: '分題統計復制',
        DataAnalysis: '數據分析',
        CrossChart: '交叉圖表',
        AddCrossAnalysis: '添加交叉分析',
        NotCrossChart: '該項目暫無交叉圖表',
        CrossChartsSupport: '交叉圖表只支持單選題和多選題',
        AddCrossChart: '添加交叉圖表',
        Argument: '自變量',
        DependentVariable: '因變量',
        HideChart: '隱藏圖表',
        HideTable: '隱藏表格',
        DisplaySettings: '顯示設置',
        TotalNumberOfInterviewees: '受訪總人數',
        RowPercentage: '行百分比',
        ChartType: '圖表類型',
        DisplayChart: '顯示圖表',
        DisplayTable: '顯示表格',
        DataScreening: '數據總覽',
        NewDataAddedToday: '今日新增數據',
        DataDetails: '數據詳情',
        SetUp: '設置',
        ExportAttachments: '導出附件',
        ExportPicture: '導出圖片',
        ExportRecording: '導出錄音',
        ExportContent: '導出內容',
        DataDetailsTable: '數據詳情表',
        DataType: '數據類型',
        RawData: '原始數據',
        CodedData: '編碼數據',
        ExhibitionFormat: '展出形式',
        OneQuestionOneColumn: '一題一列',
        OneQuestionWithMultipleColumns: '一題多列',
        Details: '詳情',
        FullName: '姓名',
        Age: '年齡',
        Year: '歲',
        Gender: '性別',
        Education: '學歷',
        CellPhoneNumber: '手機號',
        Mailbox: '郵箱',
        ID: '身份證號',
        Address: '地址',
        SampleStatusName: '樣本狀態名稱',
        ExportImageSettingsField: '導出圖片設置字段',
        Route: '路徑',
        PleaseEnterContent: '請輸入內容',
        Name: '名稱',
        LabelTip: '註意：標簽以方括號成對的形式出現，請在刪減路徑標簽時註意方括號的閉合，保證生成路徑的合法性。',
        State: '狀態',
        AllImages: '全部圖片',
        CompleteImage: '完成圖片',
        IdentifyingImages: '甄別圖片',
        ExportRecordingSettingsFields: '導出錄音設置字段',
        RecordAll: '全部錄音',
        CompleteRecording: '完成錄音',
        IdentifyingRecordings: '甄別錄音',
        Source: '來源',
        Interview: '面訪',
        TelephoneSurveys: '電訪',
        SetDisplayFields: '設置顯示字段',
        SampleFields: '樣本字段',
        WhetherToChoose: '是否選用',
        IsItFixedOnTheLeftSide: '是否左側固定',
        QuestionnaireFields: '問卷字段',
        VisitorField: '訪員字段',
        GeographicalDistribution: '地域分布',
        AccessingTheEnvironment: '訪問環境',
        ByDeviceType: '按設備類型',
        ByBrowser: '按瀏覽器',
        ByOperatingSystem: '按操作系統',
        Province: '省份',
        SetDisplay: '設置顯示',
        NumberOfRespondents: '答題人數',
        ViewChartDisplaySettings: '查看圖表顯示設置',
        DisplayByTitle: '按照題目顯示',
        Topic: '題目',
        DisplayAccordingToQuestionType: '按照題型顯示',
        
        InputTypeQuestion: '輸入類型題',
        MultipleChoiceQuestions: '多選題',
        StarRating: '星級評分',
        TrueOrFalse: '判斷題',
        DateSelection: '日期選擇',
        SortQuestion: '排序題',
        AddressLocation: '地址位置',
        CitySelection: '城市選擇',
        Timing: '時間選擇',
        MatrixTypeQuestions: '矩陣類型題',
        MatrixRadioSelection: '矩陣單選',
        MatrixMultipleSelection: '矩陣多選',
        MatrixStarRating: '矩陣星級評分',
        MatrixFillingInTheBlank: '矩陣填空',
        FillInTheBlankWithMultipleRowsOfMatrix: '矩陣多行填空',
        MatrixCombination: '矩陣組合',
        MoreQuestionTypes: '更多題型',
        Headings: '段落標題',
        Paging: '分頁',
        PersonalInformation: '個人信息',
        SingleLineInputBox: '單行輸入框',
        Career: '職業',
        UploadFiles: '上傳文件',
        FillInTheBlankHorizontally: '橫向填空',
        MultipleBlankFilling: '多項填空',
        CascadeQuestions: '級聯題',
        SpecificGravityQuestion: '比重題',
        ScaleQuestions: '量表題',
        MultilineInputBox: '多行輸入框',
        FillInTheBlanks: '填空題',
        PictureSelection: '圖片選擇',
        MultipleChoiceQuestions: '選擇類型題',
        MultipleChoice: '單選題',
        DropDownList: '下拉框',
        AnswerSheetDetails: '答卷詳情',
        AnswerInformation: '答題信息',
        TotalScore: '答題總分',
        TextReading: '文本閱讀',
        AnswerSheetReading: '答卷閱讀',
        ViewAttachments: '查看附件',
        Photo: '照片',
        NoPicturesObtained: '暫未獲取到 圖片信息',
        SoundRecording: '錄音',
        AudioNotSupported: '您的瀏覽器不支持 audio 元素。',
        Positioning: '定位',
        LocationNotObtained: '暫未獲取到 定位信息',
        IncompleteData: '數據不完整，請刷新頁面',
        SampleNumber: '樣本編號'
    },
  };